import { useEffect } from "react"

import { Layout, Typography } from "antd"
import { setIsAuthModalOpen } from 'features/common/model/slice/appSlice'
import { isAuthSelector } from "features/user/model/selectors/userSelectors"
import { userAgreementActions } from "features/user/user-agreement/model/slice/userAgreementModalSlice"
import { useLocation, useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "shared/config/store"
import { ROUTES } from "shared/constants/routesPaths"
import styled from "styled-components"

const { Header, Footer, Content } = Layout
const { Text, Link } = Typography

export default function Home() {
  const navigate = useNavigate()
  const location = useLocation()
  const isAuth = useAppSelector(isAuthSelector)
  const dispatch = useAppDispatch()
  const queryString = location.search.substring(1)


  useEffect(() => {
    if (isAuth) {
      const redirectUrl = queryString ? `${ROUTES.dashboard.allAssets}?${queryString}` : ROUTES.dashboard.allAssets
      navigate(redirectUrl)
    } else {
      const redirectUrl = `/?${queryString}`
      navigate(redirectUrl)
    }
  }, [isAuth, navigate, queryString])


  useEffect(() => {
    dispatch(setIsAuthModalOpen(!isAuth))
  }, [dispatch, isAuth])

  const handleClickUserAgreement = (type: string) => {
    dispatch(userAgreementActions.setIsUserAgreementModalOpen({
      type: type,
      tenantName: 'default',
    }))
  }

  return (
    <StyledLayout>
      {/* Header */}
      {/* <StyledHeader>
        <Flex align="center">
          <img src="/icons/aivardLogo.svg"
            alt="Company Logo"
          />
        </Flex>
      </StyledHeader> */}

      <Content />

      {/* Footer */}
      <StyledFooter>
        <Text>
          By logging in, you agree to our
          {" "}

          <SLink onClick={() => handleClickUserAgreement('terms_of_service')}>
Terms Of Use
          </SLink>

          {' '}

and
          {" "}

          <SLink onClick={() => handleClickUserAgreement('privacy_policy')}>
            Privacy Policy
          </SLink>
.
        </Text>
      </StyledFooter>
    </StyledLayout>
  )
}

const SLink = styled(Link)`
  color: var(--color-secondary) !important;
`

/* Styled Components */
const StyledLayout = styled(Layout)`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background: transparent !important;
`

const StyledFooter = styled(Footer)`
  text-align: center;
  background: transparent !important;
  padding: 16px;
  z-index: 1050;
`
